export default __webpack_public_path__ + "static/media/Gloves of Wild Furor.d67ec9a1.jpg";